<template>
  <div>
    <Warning v-if="computeTotalPropValue(0) > 100000"/>
    <FormHeading>Coverages{{computeTotalPropValue(0) > 100000 ? '' : ' and Rates'}}</FormHeading>
    <div class="table-wrapper">
      <div class="table-header">
        <h3>Covered Property</h3>
        <h3 class="right-align">Limit of Insurance</h3>
      </div>

      <div v-for="(item, index) in properties" :key="index" class="table-row">
        <div class="cell">
          <div class="row-label">
            <span v-if="item.year">
              {{ item.year }}
            </span>  
            <span>{{ item.description }}</span>
            <a class="remove" @click="removeProperty(index)">
              <font-awesome-icon class="caret" :icon="['fal', 'trash-alt']" />
            </a>
            <div class="row-bottom">
              <p v-if="item.serial">{{ item.serial }}</p>
            </div>
          </div>
        </div>
        <div class="cell">
          <p class="row-label right-align">${{ addComma(item.value)}}</p>
        </div>
      </div>
      <div class="table-footer">
        <div class="cell">
          <p class="row-label total-text">Total Property Limit of Insurance</p>
        </div>
        <div class="cell">
          <p class="row-label total right-align">${{ totalPropertiesValue }}</p>
        </div>
        <template v-if="computeTotalPropValue(0) <= 100000">
          <div class="cell">
            <p class="row-label total-text">Deductible</p>
          </div>
          <div class="cell">
            <p class="row-label total right-align">${{ totalDeductible }}</p>
          </div>
        </template>
      </div>
      <template v-if="computeTotalPropValue(0) <= 100000">
        <div class="table-header">
          <h3>Premium</h3>
          <h3 class="right-align">Amount</h3>
        </div>
        <div class="table-row">
          <div class="cell">
            <p class="row-label">Premium for Covered Property</p>
          </div>
          <div class="cell">
            <p class="row-label right-align">${{ round(totalYearlyPremium) }}</p>
          </div>
        </div>
        <div class="table-footer">
          <div class="cell">
            <p class="row-label total-text">Total Annual Premium</p>
          </div>
          <div class="cell">
            <p class="row-label total right-align">${{ round(totalYearlyPremium) }}</p>
          </div>
        </div>
      </template>
    </div>

    <div class="button-group marginBottom">
      <Button class="redOutline" @click="setStep">
        <font-awesome-icon :icon="['fal', 'plus']" />
        <span>Add Property</span>
      </Button>
    </div>
    <div class="button-group">
      <Button class="transparent" @click="prev">Back</Button>
      <Button class="red" @click="next">Continue</Button>
    </div>
  </div>
</template>

<script>
import Warning from "../Warning";
import { FormHeading, Button } from "../../style";
import { addCommaToNumber, scrollTop } from "../../utils";
export default {
  name: "CoverageRates",
  props: {
    step: {
      type: Number,
      required: true
    },
    properties: {
      type: Array,
      default: () => []
    },
    property: {
      type: Number,
      default: 1
    },
    payment: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    totalDeductible() {
      return this.addComma(this.payment.deductible);
    },
    totalYearlyPremium() {
      return this.addComma(this.payment.yearlyPremium);
    },
    totalPropertiesValue() {
      let value = 0;
      if (this.properties.length) {
        value = this.computeTotalPropValue(value);
      }
      return this.addComma(value);
    }
  },
  mounted() {
    scrollTop();
  },
  data() {
    return {
      newCoveredProperty: "",
      newCoverageLimit: "",
      newRate: ""
    };
  },
  methods: {
    next() {
      this.$emit("next-step");
    },
    prev() {
      this.$emit("prev-step");
    },
    setStep() {
      this.$emit("set-step");
    },
    addComma(price) {
      return addCommaToNumber(price);
    },
    propertiesValues(value) {
      this.properties.forEach(property => {
        value += parseInt(property.value);
      });
      return value;
    },
    computeTotalPropValue(price) {
      this.properties.forEach((property, index) => {
        if (index < this.property) {
          price += parseFloat(property.value);
        }
      });
      return price;
    },
    removeProperty(index) {
      this.$confirm("Are you sure you want to remove property?", "", {
        confirmButtonText: "Remove",
        cancelButtonText: "Cancel"
      })
        .then(() => {
          this.$emit("remove-property", index);
        })
        .catch(() => {});
    },
    round(price) {
      return Math.round(price);
    }
  },
  components: {
    FormHeading,
    Button,
    Warning
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.button-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  button {
    svg + span {
      margin-left: $padding-md;
    }
  }
  button:last-of-type {
    margin-left: $padding-lg;
  }
  &.marginBottom {
    margin-bottom: 2.5rem;
  }
}
.row-label {
  .remove {
     cursor: pointer;
      color: $blue-navy;
      font-size: $font-size-xs;
      position: relative;
      margin-left: $padding-sm;
  }
}

</style>
